module.exports = __webpack_public_path__ + "static/media/tomatoes-explore-more.67a2a6e2.jpg";